const dataExport = {
  export: 'ייצא',
  errorMessage: 'ייצוא הנתונים נתקל בשגיאות בלתי צפויות.',
  waitForDownloadMessage: 'הבקשה נשלחה, ההורדה שלך תתחיל בקרוב.',
  exportToCsv: {
    title: 'ייצא קובץ CSV',
    body: 'אתה עומד לייצא קובץ CSV עבור {{selectedCount}} {{itemsLabel}}.',
  },
};

export default dataExport;
